export const LuxuryWaves = () => {
  return (
    <div className="wave-container">
      <div className="wave" />
      <div className="wave wave-2" />
      <div className="wave wave-3" />
    </div>
  );
};

export const SubtleWaves = ({ className }: { className?: string }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {/* Soft feminine flowing waves - lavender & cream accents */}
      <div 
        className="absolute w-full h-full opacity-30"
        style={{
          background: `
            radial-gradient(ellipse 1000px 400px at 0% 50%, hsl(var(--lavender) / 0.2) 0%, transparent 60%),
            radial-gradient(ellipse 800px 300px at 100% 80%, hsl(var(--purple-soft) / 0.15) 0%, transparent 60%),
            radial-gradient(ellipse 600px 200px at 50% 20%, hsl(var(--gold) / 0.08) 0%, transparent 60%)
          `,
          animation: 'wave-flow 50s linear infinite',
        }}
      />
      <div 
        className="absolute w-full h-full opacity-20"
        style={{
          background: `
            radial-gradient(ellipse 700px 250px at 30% 70%, hsl(var(--lavender-light) / 0.1) 0%, transparent 70%),
            radial-gradient(ellipse 500px 300px at 70% 30%, hsl(var(--cream) / 0.3) 0%, transparent 70%)
          `,
          animation: 'wave-flow 60s linear infinite reverse',
        }}
      />
    </div>
  );
};